/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import getMeta from '../get-meta/index.tsx';

const TAP_VALUES: Record<string, string> = {
	f: 'free',
	s: 'standard',
	p: 'premium',
};
const getTapValue = (editionShorthand: string) => TAP_VALUES[editionShorthand] ?? 'UNLICENSED';

export const getProductEditions = (): {
	'jira-software_edition': string;
	'jira-servicedesk_edition': string;
	'jira-workmanagement_edition': string;
} => {
	try {
		const tenantContextEditions = JSON.parse(getMeta('ajs-product-editions') || '{}');

		return {
			'jira-software_edition': getTapValue(tenantContextEditions['jira-software']),
			'jira-servicedesk_edition': getTapValue(tenantContextEditions['jira-servicedesk']),
			'jira-workmanagement_edition': getTapValue(tenantContextEditions['jira-core']),
		};
	} catch (error: unknown) {
		// oxlint-disable-next-line no-console
		console.warn(`Error parsing application editions from tenant context: ${error}`);

		return {
			'jira-software_edition': 'UNLICENSED',
			'jira-servicedesk_edition': 'UNLICENSED',
			'jira-workmanagement_edition': 'UNLICENSED',
		};
	}
};
